<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月10日 16:01:48 +0800
 * @最后修改时间: 2022-02-18 10:44:10
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Holiday\PublicHolidayGroup\newPublicHolidayGroup.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_holidayGroup_form_newTitle')"
    widthClass="max-1000"
    pad="0"
    :initData="publicHolData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'holiday_group_name',
      'holiday_group_description',
      'holiday_group_code',
      'remarks',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Stepper :curStep="curStep" :items="stepper">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  maxlength="100"
                  :bindData="publicHolData.holiday_group_name"
                  @change="
                    (valueArr) => {
                      publicHolData.holiday_group_name = valueArr;
                    }
                  "
                  :label="
                    $t('label_essweb_holidayGroup_form_publicHolidayGroupLabel')
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  :label="$t('label_essweb_ClaimReason_form_codeLabel')"
                  maxlength="100"
                  :rules="
                    $GetRules(['_Require_Rules', '_Length_Rules'], [null, 100])
                  "
                  v-model="publicHolData.holiday_group_code"
                />
              </v-col>
              <!-- <v-col  xs='12' sm="12" md='12' lg='12' cols="12">
                <inputTextFiledMultiLang
                  filled
                  single-line
                  dense
                  popClass="full-width"
                  :bindData="publicHolData.holiday_group_description"
                  @change="
                    (valueArr) => {
                      publicHolData.holiday_group_description = valueArr;
                    }
                  "
                  label="Description"
                />
              </v-col>
              <v-col  xs='12' sm="12" md='12' lg='12' cols="12">
                Remarks
                <v-textarea rows='3' no-resize
                  maxlength="150"
                  dense
                  filled
                  single-line
                  v-model="publicHolData.remarks"
                  name="input-7-4"
                  label="Remarks"
                ></v-textarea>
              </v-col>-->
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <v-card :elevation="0" class="pa-0">
            <v-card-text class="pa-0">
              <Tabler
                :headers="headers"
                :showNoContent="false"
                :items="desserts"
                :showSelect="showSelect"
              >
                <template v-slot:item.name="{ item }">
                  {{ $getCommonLangValue(item.holiday_name) }}
                </template>
                <template v-slot:item.date="{ item }">
                  {{ $getDateTime(item.holiday_utc_date, "YYYY/MM/DD") }}
                </template>
                <template v-slot:item.utc="{ item }">
                  {{ $getUtcByCode(item.holiday_time_zone) }}
                </template>
              </Tabler>
            </v-card-text>
            <v-card-actions class="pb-0 pl-0">
              <v-btn
                text
                color="primary"
                small
                class="text-capitalize mb-3"
                @click="toNewMapping"
              >
                {{ $t("label_essweb_holidayGroup_form_editHolidayBtnLabel") }}
                <span class="material-icons-round">add</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </Stepper>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        :newBtn="stepper.length == curStep && curStep != 0 ? true : false"
        :step="stepper.length == curStep ? false : true"
        @next="toNext"
        :preStep="curStep > 1 ? true : false"
        @pre="curStep = curStep - 1"
        @new="toNew"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main>
      <mapToPublicHoliday
        :show="mapToDiag"
        :action="curAction"
        :PorpertyData="curPorperty"
        @newPorperty="onNewProperty"
        @editPorperty="onEditProperty"
        @closeDialog="mapToDiag = false"
      />
    </template>
  </ContentLayout>
</template>
<script>
import mapToPublicHoliday from "@/Page/EssAdmin/Holiday/PublicHolidayGroup/components/mapToPublicHoliday";
import { mapGetters } from "vuex";
export default {
  name: "newPublicHolidayGroup",
  components: { mapToPublicHoliday },
  computed: {
    ...mapGetters(["companyLang"]),
  },
  data() {
    return {
      curStep: 1,
      isChanged: false,
      stepper: [
        "label_essweb_holidayGroup_form_step_generalLabel",
        "label_essweb_holidayGroup_form_step_holidayListLabel",
      ],
      mapToDiag: false,
      curAction: "new",
      curPorperty: null,
      selected: [],
      curPropertyId: null,
      page: 1,
      showSelect: false,
      publicUuids: [],
      publicYears: [],
      publicHolData: {
        holiday_group_name: "",
        holiday_group_code: "",
        holiday_group_description: "",
        remarks: "",
      },
      headers: [
        {
          text: "label_essweb_holidayGroup_form_holidayNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_holidayGroup_form_holidayDateLabel",
          value: "date",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_holidayGroup_form_holidayZoneLabel",
          value: "utc",
          align: "start",
          sortable: false,
        },
      ],
      desserts: [],
    };
  },
  watch: {
    desserts(val) {
      const that = this;
      that.publicUuids = [];
      that.publicYears = [];
      this.curPorperty = val;
      val.forEach(function (item) {
        that.publicUuids.push(item.uuid);
        that.publicYears.push(item.year);
      });
    },
  },
  mounted() {
    // this.publicHolData.holiday_group_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.publicHolData.holiday_group_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
  },
  methods: {
    toNext: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.curStep = this.curStep + 1;
    },
    toNew: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_group",
        url: "/holiday-group/add-holiday-group-table/",
        data: {
          holiday_group_name: this.$transCommonLangKey(
            this.publicHolData.holiday_group_name
          ),
          holiday_group_code: this.publicHolData.holiday_group_code,
          // holiday_group_description: this.$transCommonLangKey(
          //   this.publicHolData.holiday_group_description
          // ),
          // remarks: this.publicHolData.remarks,
          holidays: {
            uuids: that.publicUuids.join(","),
            years: that.publicYears.join(","),
          },
        },
      }).then((res) => {
        that.$toBack();
      });
    },
    toNewMapping: function () {
      const that = this;
      this.curAction = "edit";
      this.curPorperty = [];
      this.$Sleep(300).then(() => {
        that.curPorperty = that.desserts;
      });
      this.mapToDiag = true;
    },
    onNewProperty: function (obj) {
      this.mapToDiag = false;
      this.desserts = obj;
    },
    onEditProperty: function (obj) {
      this.mapToDiag = false;
      this.desserts = obj;
    },

    toDeletePG: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "",
        url: "",
        data: { uuids: this.curPropertyId },
      }).then((res) => {
        that.$toBack();
      });
    },
  },
};
</script>
